import {
  AUDIT_EVENTS_REQUEST,
  AUDIT_EVENTS_SUCCESS,
  AUDIT_EVENTS_ERROR,
} from "../types";

const initialState = {
  rows: [],
  totalElements: 0,
  eventsFetched: 0,
  appliedFilters: {},
  isFetching: false,
  error: null,
};

const auditEventsReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case AUDIT_EVENTS_REQUEST:
      return { ...state, isFetching: true, error: null };
    case AUDIT_EVENTS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        rows: action.payload.rows,
        totalElements: action.payload.totalElements,
        eventsFetched: action.payload.eventsFetched,
        appliedFilters: action.payload.appliedFilters,
      };
    case AUDIT_EVENTS_ERROR:
      return { ...state, isFetching: false, error: action.payload };
    default:
      return state;
  }
};

export default auditEventsReducer;
